import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import Grid from '@mui/material/Grid';
import EventIcon from '@mui/icons-material/Event';
import CakeIcon from '@mui/icons-material/Cake';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';

const StyledPage = styled('div')(({ theme }) => ({
  padding: theme.spacing(4),
  backgroundColor: '#f0f2f5',
  minHeight: 'calc(100vh - 74px)',
  display: 'flex'
}));

const StyledCard = styled(Card)(({ theme }) => ({
  width: 300,
  height: 200,
  borderRadius: '12px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
  transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
  },
}));

const StyledCardContent = styled(CardContent)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: '100%',
  padding: theme.spacing(3),
}));

const StyledTitle = styled(Typography)(({ theme }) => ({
  color: '#4b0082',
  fontWeight: 'bold',
  fontSize: '1.25rem',
  marginBottom: theme.spacing(1),
}));

const StyledDescription = styled(Typography)(({ theme }) => ({
  color: '#666',
  fontSize: '0.9rem',
}));

const IconContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#4b0082',
  borderRadius: '50%',
  width: 50,
  height: 50,
  marginBottom: theme.spacing(2),
  '& svg': {
    color: '#fff',
    fontSize: '1.5rem',
  },
}));

const Calendars = () => {
  const calendarsMenuOptions = [
    {
      title: 'Calendario de eventos',
      description: 'Mostrar el calendario completo de todos los eventos programados.',
      path: `/events/events-full-calendar`,
      icon: <EventIcon />,
    },
    {
      title: 'Calendario de cumpleaños',
      description: 'Mostrar el calendario con todos los cumpleaños próximos.',
      path: `/events/birthdays-full-calendar`,
      icon: <CakeIcon />,
    },
    {
      title: 'Lista de cumpleaños',
      description: 'Lista detallada de los próximos cumpleaños.',
      path: `/events/birthday-list`,
      icon: <CardGiftcardIcon />
    }
  ];
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    setTimeout(() => {
      navigate(path);
    }, 100);
  };

  return (
    <StyledPage>
      <Grid container spacing={4}>
        {calendarsMenuOptions.map((option, index) => (
          <Grid item key={index}>
            <StyledCard>
              <CardActionArea sx={{ height: '100%' }} onClick={() => handleNavigate(option.path)}>
                <StyledCardContent>
                  <div>
                    <IconContainer>{option.icon}</IconContainer>
                    <StyledTitle gutterBottom variant="h5">
                      {option.title}
                    </StyledTitle>
                    <StyledDescription variant="body2">
                      {option.description}
                    </StyledDescription>
                  </div>
                </StyledCardContent>
              </CardActionArea>
            </StyledCard>
          </Grid>
        ))}
      </Grid>
    </StyledPage>
  );
};

export default Calendars;